import { Link } from "react-router-dom";
import { BRANDS } from "../data/content";

export const Footer = () => (
  <footer className="bg-[#132619] text-[#FAF4E9] px-6 py-20" data-testid="footer">
    <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <p className="font-serif-d text-3xl leading-tight">Ready to overcome <span className="italic-emph text-[#DCBB6C]">& overflow?</span></p>
        <p className="mt-4 text-[#FAF4E9]/70 max-w-md font-sans-d">You were built for more than survival. Let's build your next season together.</p>
        <Link to="/contact" data-testid="footer-cta"
          className="inline-block mt-8 bg-[#C0953A] text-[#132619] hover:bg-[#DCBB6C] transition-colors px-8 py-4 uppercase tracking-widest text-xs font-semibold">
          Start the Conversation →
        </Link>
      </div>
      <div>
        <p className="eyebrow mb-4">The Hub</p>
        <ul className="space-y-2 text-sm text-[#FAF4E9]/80">
          <li><Link to="/transform" className="hover:text-[#DCBB6C]">Coaching & Academy</Link></li>
          <li><Link to="/read" className="hover:text-[#DCBB6C]">Author & Books</Link></li>
          <li><Link to="/listen" className="hover:text-[#DCBB6C]">Music & Podcast</Link></li>
          <li><Link to="/belong" className="hover:text-[#DCBB6C]">Ministry</Link></li>
          <li><Link to="/invite" className="hover:text-[#DCBB6C]">Speaking</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-4">Reach Me</p>
        <ul className="space-y-2 text-sm text-[#FAF4E9]/80">
          <li>joyreborncorp@gmail.com</li>
          <li>coachnata.org</li>
          <li>Philadelphia, PA · Texas</li>
          <li>
            <a
              data-testid="footer-instagram-link"
              href="https://instagram.com/thereachcoachnata"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#DCBB6C] transition-colors"
            >IG @thereachcoachnata</a>
          </li>
          <li>
            <a
              data-testid="footer-tiktok-link"
              href="https://tiktok.com/@lifewithnata"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#DCBB6C] transition-colors"
            >TikTok @lifewithnata</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-16 pt-10 border-t border-[#FAF4E9]/10 flex flex-wrap items-center gap-x-10 gap-y-6" data-testid="footer-brand-logos">
      {BRANDS.map((b) => (
        <div key={b.name} className="flex items-center gap-3">
          <span className="bg-[#FAF4E9] rounded-full p-1.5 flex items-center justify-center">
            <img src={b.logo} alt={b.name} className="h-9 w-9 object-contain" />
          </span>
          <span className="text-xs text-[#FAF4E9]/60 uppercase tracking-widest">{b.name}</span>
        </div>
      ))}
    </div>
    <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-[#FAF4E9]/10 text-xs text-[#FAF4E9]/40 flex flex-col md:flex-row justify-between gap-2">
      <span>© {new Date().getFullYear()} Life With Nata — Overcome & Overflow.</span>
      <span>Focus. Faith. Strategy. Fun.</span>
    </div>
  </footer>
);
